import _merge from 'lodash/merge';
import _forEach from 'lodash/forEach';
import _find from 'lodash/find';
import _sortBy from 'lodash/sortBy';
import _cloneDeep from 'lodash/cloneDeep';
import _replace from 'lodash/replace';
import _lowerCase from 'lodash/lowerCase';

import TranslitInstance from '@/tools/translit';

/** @private */
const Translit = new TranslitInstance();

/**
 * @private
 * @class
 * @memberof Product
 *
 * @description
 * Класс для подготовки опций
 */

var Options = function(_option_names, _variants) {
  var self = this;

  _merge(self.getOptions(), self._build(_option_names, _variants[0]));

  _forEach(_variants, function(variant) {
    self._addValues(variant.option_values);
  });

  //console.debug('Options: constructor: self: ', self);
  return self;
};

/**
 * @private
 * @method
 *
 * @description
 * Строим навигационную структуру опций-значений для ускорения работы интерфейсных скриптов.
 * Учитываем варинат, когда у товара могут отсутствовать опции, либо товар содержит фейковый вариант-заглушку.
 *
 * @param {WTF} _option_names - список опций
 * @param {Object} variant - первый вариант в товаре
 *
 * @return {WTF} - готовая навигационная структура
 */
Options.prototype._build = function(_option_names, variant) {
  var self = this;

  var _options = _sortBy(_cloneDeep(_option_names), 'position');

  if (_options.length && (variant.id != 0)) {
    _options = _forEach(_options, function(option) {
      return self._mutateOption(option);
    });
  } else {
    _options.push({
      handle: '_empty',
      title: '_empty',
      values: {},
      position: 0,
      id: 0
    });
  }

  return _options;
};

/**
 * @private
 * @method
 *
 * @description
 * Правильно готовим опции
 */
Options.prototype._mutateOption = function(option) {
  var self = this;

  option.handle = Translit.replace(option.title);
  option.name = _lowerCase(_replace(option.title, 'й', 'й'));

  option.values = {};

  return option;
};

/**
 * @private
 * @method
 *
 * @description
 * Добавляем значения
 */
Options.prototype._addValues = function(_option_values) {
  var self = this;

  const sortedValues = _sortBy(_option_values, 'position');

  _forEach(sortedValues, function(value) {
    var _option = _find(self.getOptions(), { id: value.option_name_id });

    value.name = _lowerCase(_replace(value.title, 'й', 'й'));

    _option.values[value.position] = value;
  });

  return;
};

/**
 * @private
 * @method
 */
Options.prototype.getOptions = function() {
  var self = this;

  return self;
};

export default Options;
